import React from 'react'
import { formatUSD } from '@App/helpers/format-currency'
import { PayeeRoyalties } from '@Entities/statements/payee-royalties'
import RightsholderRoyaltiesPayeeDownloadLink from '@Scenes/RightsholderScene/RightsholderRoyaltiesPayeeDownloadLink'

interface RoyaltiesAnnualStatementsRowProps {
    sendTSVRequest: (payeeId: number) => void
    payeeRoyalties: PayeeRoyalties
}

const RoyaltiesAnnualStatementsRow = (props: RoyaltiesAnnualStatementsRowProps) => {
    const { sendTSVRequest, payeeRoyalties } = props
    return (
        <tr>
            <td>{payeeRoyalties.publisherNumber}</td>
            <td className="bold">{payeeRoyalties.payeeName}</td>
            <td>
                <div className="currency">
                    <p>{formatUSD(payeeRoyalties.openingBalanceAmount)}</p>
                </div>
            </td>
            <td>
                <div className="currency">
                    <p>{formatUSD(payeeRoyalties.royaltiesAmount + payeeRoyalties.adjustmentsAmount)}</p>
                </div>
            </td>
            <td>
                <div className="currency">
                    <p>{formatUSD(payeeRoyalties.payableBalanceAmount)}</p>
                </div>
            </td>
            <td>
                <div className="currency">
                    <p>{formatUSD(payeeRoyalties.paymentAmount)}</p>
                </div>
            </td>
            <td>
                <div className="currency">
                    <p>{formatUSD(payeeRoyalties.closingBalanceAmount)}</p>
                </div>
            </td>
            <td>
                <RightsholderRoyaltiesPayeeDownloadLink payeeRoyalties={payeeRoyalties} />
            </td>
            <td className="no-right-border">
                <a className="small" onClick={() => sendTSVRequest(payeeRoyalties.ipId)} href="#">
                    Download
                </a>
            </td>
        </tr>
    )
}

export default RoyaltiesAnnualStatementsRow
